import { Injectable } from "@angular/core";
import { AbstractParser } from "./parser";
import { Toast } from "../../components/toast/toast";

@Injectable()
export class GetFileExportStatusParser extends AbstractParser<boolean> {
  constructor(private toast: Toast) {
    super();
  }

  parse(payload: any): boolean {
    const isFileExportReady: boolean = payload.Exported;
    return isFileExportReady;
  }

  parseNumber(payload: any): number {
    const isFileExportReady: boolean = payload.Exported;
    const hasError: boolean = payload.HasError;
    if (hasError) {
      return -1;
    } else if (isFileExportReady) {
      this.toast.showSuccessToast("O relatório está pronto para download!");
      return 1;
    }
    return 0;
  }
}
